import { render, staticRenderFns } from "./FormValidate.vue?vue&type=template&id=6c23be34&scoped=true"
import script from "./FormValidate.vue?vue&type=script&lang=js"
export * from "./FormValidate.vue?vue&type=script&lang=js"
import style0 from "./FormValidate.vue?vue&type=style&index=0&id=6c23be34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c23be34",
  null
  
)

export default component.exports